import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import api from '../utils/api';
import TMISLogo from '../img/tmis_logo_orig.png'
import TMISLogoWhite from '../img/tmis_logo_w.png'

export default function LoginPage() {
  const { login } = useAuth();
  const { theme } = useTheme();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [msLoading, setMsLoading] = useState(false);

  useEffect(() => {
    const authError = searchParams.get('auth_error');
    if (authError) setError(decodeURIComponent(authError));
  }, [searchParams]);

  async function handleLogin(e) {
    e.preventDefault();
    if (!email || !password) { setError('Please enter your email and password.'); return; }
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/api/auth/login', { email, password });
      if (res.data.success) {
        // Fetch permissions
        const meRes = await api.get('/api/auth/me', {
          headers: { Authorization: `Bearer ${res.data.token}` }
        });
        login(res.data.token, meRes.data.user, meRes.data.permissions);
        navigate('/home');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  async function handleMS365() {
    setMsLoading(true);
    setError('');
    try {
      const res = await api.get('/api/auth/ms365/url');
      window.location.href = res.data.url;
    } catch (err) {
      setError('Failed to initiate Microsoft 365 login.');
      setMsLoading(false);
    }
  }

  return (
    <div className="login-wrapper">
      <div className="login-card">
        {/* Logo */}
        <div className="text-center mb-4">
          <img src={theme === 'dark' ? TMISLogoWhite : TMISLogo} alt="TMIS Logo" className="w-75"/>
          {/* <div style={{ display: 'inline-flex', alignItems: 'center', gap: 2, marginBottom: 6 }}>
            <span style={{ fontSize: '2.5rem', fontWeight: 900, color: '#0d2137', letterSpacing: '-2px', lineHeight: 1 }}>
              TM<span style={{ color: '#17a2b8' }}>i</span>S
            </span>
          </div>
          <div style={{ color: '#718096', fontSize: '0.75rem', letterSpacing: '0.5px' }}>
            Tourism Management Institute of Singapore
          </div> */}
        </div>

        {/* MS365 Button */}
        {/* <button className="btn-ms365" onClick={handleMS365} disabled={msLoading} aria-label="Continue with Microsoft 365">
          {msLoading ? (
            <span className="spinner-border spinner-border-sm" />
          ) : (
            <svg width="20" height="20" viewBox="0 0 21 21" aria-hidden="true">
              <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
              <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
              <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
            </svg>
          )}
          Continue with Microsoft 365
        </button> */}

        <div className="divider-text">Sign in with SEMS</div>

        {/* Error */}
        {error && (
          <div className="alert alert-danger inline-error mb-3 d-flex align-items-center gap-2" role="alert">
            <i className="bi bi-exclamation-circle-fill flex-shrink-0" />
            {error}
          </div>
        )}

        {/* Email/Password Form */}
        <form onSubmit={handleLogin} noValidate>
          <div className="mb-3">
            <label className="form-label" htmlFor="login-email">Username</label>
            <input
              id="login-email"
              type="email"
              className="form-control"
              placeholder="you@tmis.edu.sg"
              value={email}
              onChange={e => { setEmail(e.target.value); setError(''); }}
              autoComplete="email"
              required
            />
          </div>
          <div className="mb-4">
            <label className="form-label" htmlFor="login-password">Password</label>
            <div className="input-group">
              <input
                id="login-password"
                type={showPw ? 'text' : 'password'}
                className="form-control"
                placeholder="••••••••"
                value={password}
                onChange={e => { setPassword(e.target.value); setError(''); }}
                autoComplete="current-password"
                required
              />
              <button type="button" className="btn btn-outline-secondary" onClick={() => setShowPw(!showPw)} aria-label={showPw ? 'Hide password' : 'Show password'}>
                <i className={`bi ${showPw ? 'bi-eye-slash' : 'bi-eye'}`} />
              </button>
            </div>
          </div>
          <button
            type="submit"
            className="btn btn-tmis-primary w-100 d-flex align-items-center justify-content-center gap-2"
            style={{ padding: '10px', fontWeight: 600 }}
            disabled={loading}
          >
            {loading ? <span className="spinner-border spinner-border-sm" /> : <i className="bi bi-lock-fill" />}
            Sign In
          </button>
        </form>

        <p className="text-center mt-4 mb-0" style={{ fontSize: '0.75rem', color: 'var(--tmis-muted)' }}>
          Authorised personnel only · TMIS Internal System
        </p>
      </div>
    </div>
  );
}
